export default "__VITE_ASSET__DMMfbm8D__"